import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformationModalComponent } from './information-modal.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [
    InformationModalComponent
  ],
  exports: [
    InformationModalComponent
  ]
})

export class InformationModalModule { }
